import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import LegalLayout from './LegalLayout';

const privacyPolicyContent = `
# プライバシーポリシー

Sink（以下「本サービス」といいます）は、ユーザーの思考、メモ、会話ログを安全に保存し、AIによる整理・再発見を支援するサービスです。本プライバシーポリシーは、本サービスにおけるユーザー情報の取扱いについて説明するものです。

## 1. 取得する情報

本サービスは、以下の情報を取得することがあります。

### アカウント情報

- メールアドレス
- Googleアカウント等の認証に必要な識別子
- Firebase Authにより発行されるユーザーID
- トライアル参加可否、ロール、allowlistに関する情報

### ユーザーが入力・作成する情報

- Sinkに投稿したRawメッセージ、メモ、会話ログ
- Note、Hint、Asset、タグ、リンク等の整理済みデータ
- AI Buddy / Anti Buddyとの会話内容
- 添付・URL・音声等を将来対応する場合、それらの入力内容

### AI機能の利用に関する情報

- 利用したAI機能の種類
- 利用日時
- provider / model
- token数、credit目安、処理結果、エラー情報
- 関連するRoom、Note、Hint、Asset等のID

### 技術情報

- ブラウザ、端末、OS等の情報
- IPアドレス、アクセス日時、参照元等のログ
- Cookie、localStorage、IndexedDB等に保存される設定情報
- APIキー、provider/model設定等。ただし自分のAPIキー（BYOK）は、現在のMVPではユーザーのブラウザlocalStorageに保存され、Sinkサーバーには保存しません。

## 2. 利用目的

本サービスは、取得した情報を以下の目的で利用します。

- 本サービスの提供、認証、アカウント管理のため
- Raw、Note、Hint、Asset、タグ、リンク等を保存・表示・検索するため
- AIによるNoteまとめ、Hint抽出、AI Buddy / Anti Buddy応答、関連知識の提示を行うため
- ユーザーごとのデータを分離し、不正アクセスを防止するため
- 利用量、credit目安、エラー状況を記録し、安定運用や改善に役立てるため
- 問い合わせ、本人確認、サポート対応のため
- 不正利用、規約違反、セキュリティ上の問題を検知・防止するため
- サービス改善、品質向上、利用状況分析のため
- 法令または公的機関からの正当な要請に対応するため

## 3. AI providerへの送信

本サービスのAI機能では、ユーザーが入力した内容、関連するNote / Hint / Asset、直近の会話履歴、選択中のタグや文脈情報を、AI応答生成のために外部のAI providerへ送信することがあります。

送信される情報は、利用する機能や設定により異なります。

- Noteまとめ: 対象RoomのRawメッセージ、ユーザーが入力した補足指示
- Hint抽出: 対象Note、関連するHint / Asset、タグ情報
- AI Buddy / Anti Buddy: ユーザーの質問、直近の会話、関連すると判断されたAsset / Note / Hint
- 自分のAPIキー（BYOK）利用時: ユーザーが選択したproviderへ、ユーザーのブラウザから直接リクエストを送信

本サービスが標準AIとして使用するproviderおよびモデルは以下の通りです。

- 軽量処理（チャット・文脈選択等）: Google Gemini（gemini-3.1-flash-lite）
- 重量処理（Noteまとめ・Hint抽出・Asset合成等）: Google Gemini（gemini-2.5-flash）

これらのリクエストはCloudflare Pages Functionsを経由して送信されます。Google AI Studio APIのデータ利用条件を確認しており、送信データはGoogleのAIモデルの学習に使用されません。

自分のAPIキー（BYOK）を利用する場合は、ユーザーが選択したprovider（OpenAI / Anthropic / Google Gemini等）へブラウザから直接リクエストが送信されます。providerごとの詳細は、利用中のproviderの規約およびプライバシーポリシーも確認してください。

## 4. 自分のAPIキー（BYOK）の取扱い

ユーザーが自身のOpenAI、Anthropic、Gemini等のAPIキーを設定する場合、現在のMVPでは、APIキーはユーザーのブラウザlocalStorageに保存されます。Sinkサーバーには保存しません。

ただし、localStorageは利用端末・ブラウザ上に保存される仕組みであり、共有端末やマルウェア、ブラウザ拡張機能等により漏えいするリスクがあります。共有端末では自分のAPIキー（BYOK）を利用しないでください。

将来、本番環境ではAPIキーの保存方式、暗号化、backend proxy経由の利用方式を見直す場合があります。

## 5. 第三者提供・外部委託

本サービスは、以下の場合を除き、ユーザーの個人情報を本人の同意なく第三者に提供しません。

- 法令に基づく場合
- 生命、身体、財産の保護のために必要な場合
- 公的機関から正当な要請を受けた場合
- サービス提供に必要な範囲で、クラウド、認証、AI provider、決済、外部サブスクリプション確認、分析等の外部サービスに処理を委託する場合

現時点で想定する主な外部サービスは以下です。

- Firebase / Google Cloud: 認証、Firestore、Hosting等
- Google Forms: Waitlist受付
- OpenAI、Anthropic、Google Gemini / Google AI Studio: AI機能
- Cloudflare: backend proxy、配信、セキュリティ
- note等: 初期リリースでの外部サブスクリプション/支援者確認、クレジット付与運用
- Stripe: アプリ内の決済（月額サブスクリプション・クレジットパック）の処理
- Google Analytics（GA4）: ランディングページ、デモページおよびアプリ本体のアクセス解析に利用

## 6. 安全管理

本サービスは、ユーザー情報を保護するため、以下のような安全管理措置を講じます。

- Firebase Authによる認証
- allowlistによるトライアルアクセス制御
- Firestore rulesによるユーザーごとのデータ分離
- \`ownerUid\` によるデータ所有者管理
- APIキーやsecretをリポジトリへ含めない運用
- backend利用時の認証token検証、rate limit、usage logging
- 不要なデータ送信を避けるためのAI文脈選択

## 7. 保存期間と削除

本サービスは、利用目的の達成に必要な範囲でユーザー情報を保存します。

ユーザーは、問い合わせにより、自身のアカウント情報および保存データの削除を求めることができます。削除依頼はメール（info@mqgauss.com）にて受け付けます。本人確認のうえ、合理的な期間内に対応します。

## 8. 開示、訂正、利用停止等

ユーザー本人から、個人情報の開示、訂正、追加、削除、利用停止等の請求があった場合、法令に従い、本人確認のうえ合理的な範囲で対応します。

## 9. Cookie等の利用

本サービスは、ログイン状態、設定、APIキー、表示設定等を保持するため、Cookie、localStorage、IndexedDB等を利用することがあります。

本サービスは、ランディングページ、デモページおよびアプリ本体においてGoogle Analytics（GA4）を利用しています。GA4はページ閲覧情報（ページタイトル・パス）およびサービス利用状況を収集しますが、ユーザーの入力内容・メモ・会話ログ等のデータは収集しません。

## 10. 未成年の利用

未成年者が本サービスを利用する場合、必要に応じて親権者等の同意を得て利用してください。

## 11. プライバシーポリシーの変更

本サービスは、必要に応じて本ポリシーを変更することがあります。重要な変更がある場合、アプリ内表示、LP、メール等の適切な方法で通知します。

## 12. 問い合わせ窓口

本ポリシーに関する問い合わせは、以下の窓口までお願いします。

- 運営者: 合同会社レインバレーズ
- メールアドレス: info@mqgauss.com

最終更新日: 2026年5月31日
`;

export default function PrivacyPolicy() {
  return (
    <LegalLayout>
      <div className="markdown-body">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {privacyPolicyContent}
        </ReactMarkdown>
      </div>
    </LegalLayout>
  );
}
